<template>
  <section class="ddt-card">
    <header v-if="$slots.header" class="ddt-card__header"><slot name="header" /></header>
    <div class="ddt-card__body"><slot /></div>
    <footer v-if="$slots.footer" class="ddt-card__footer"><slot name="footer" /></footer>
  </section>
</template>
